import { apiGet } from '@/app/Dataman';
import { FIND_SIMILAR_PATHS } from './paths';

export default {
  getSimilarProducts: (productId, filter = {}) => {
    return apiGet(`${FIND_SIMILAR_PATHS.similarProducts}/${productId}/similar-products`, filter);
  },
};
